import { ParserHelper } from "../ParserHelper";
export class TeamTennisScoreParser {
    constructor() { }
    static get instance() {
        if (!TeamTennisScoreParser._instance) {
            TeamTennisScoreParser._instance = new TeamTennisScoreParser();
        }
        return TeamTennisScoreParser._instance;
    }
    parse(sportEvent, isTeamSwapEnabled) {
        let currentGameScore1 = ParserHelper.instance.getAdditionalScore(sportEvent, "currentGameScore1");
        let currentGameScore2 = ParserHelper.instance.getAdditionalScore(sportEvent, "currentGameScore2");
        return !isTeamSwapEnabled
            ? { Home: currentGameScore1, Away: currentGameScore2 }
            : { Home: currentGameScore2, Away: currentGameScore1 };
    }
}
;
//# sourceMappingURL=TeamTennisScoreParser.js.map